import { useEffect } from 'react'

import { useParams } from 'react-router'

import { useTransmissionContext } from 'modules/transmission/context'
import useFetchTransmission from 'modules/transmission/hooks/useFetchTransmission'

interface Params {
  hash: string
}

const useSetupTransmission = () => {
  const { hash: transmissionCode } = useParams<Params>()

  const { setTransmissionCode } = useTransmissionContext()

  const fetchTransmission = useFetchTransmission()

  useEffect(() => {
    setTransmissionCode(transmissionCode)
  }, [transmissionCode, setTransmissionCode])

  useEffect(() => {
    fetchTransmission()
  }, [fetchTransmission])
}

export default useSetupTransmission
